import { render, staticRenderFns } from "./AccountCoin.vue?vue&type=template&id=cda5c722&scoped=true"
import script from "./AccountCoin.vue?vue&type=script&lang=js"
export * from "./AccountCoin.vue?vue&type=script&lang=js"
import style0 from "./AccountCoin.vue?vue&type=style&index=0&id=cda5c722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda5c722",
  null
  
)

export default component.exports